import { Component, OnInit } from '@angular/core';
import {Project,} from "../../../Models/project";
import {ActivatedRoute} from "@angular/router";
import {ProjectService} from "../../../Services/project.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-projects-details',
  templateUrl: './projects-details.component.html',
  styleUrls: ['./projects-details.component.scss']
})
export class ProjectsDetailsComponent implements OnInit {
    projectId = '';
    project: Project ;
    constructor(private activatedRoute: ActivatedRoute, private projectServ: ProjectService) { }

    ngOnInit(): void {
        this.projectId = this.activatedRoute.snapshot.paramMap.get('id') ;
        this.projectServ.getProject(this.projectId).subscribe(data => {
            if (data.succeeded){
                this.project = data.data;
            }
        });
    }

    protected readonly environment = environment;
}
